<template>
  <!-- 对话框 -->
  <el-dialog title="添加优享司机" :visible.sync="show" :before-close="closeDialog"  style="width:60%; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box">
      <el-form label-width="80px">


        <el-form-item label="增加天数:" label-width='120px'>
          <el-input v-model="submit_data.day_num" :placeholder="submit_rules.day_num.placeholder"
            @input="getMoney">
          </el-input>

          <p>
            <el-tag>{{ money }} 元 </el-tag>
          </p>

        </el-form-item>

        <el-form-item label="实付金额:" label-width='120px'>
          <el-input v-model="submit_data.real_amount" :placeholder="submit_rules.real_amount.placeholder">
          </el-input>
        </el-form-item>
      </el-form>

      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="enjoySubmit">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;

  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.submit_data.driver_code = _this.data;


      },

    },
    data() {
      return {

        show: false,

        // 需要钱数
        money: 0,

        // 表单数据
        submit_data: {
          driver_code: '',
          day_num: '',
          real_amount: ''
        },

        submit_rules: {
          day_num: {
            placeholder: '请输入增加优享司机天数',
            rules: {
              required: true,
              message: '未输入天数',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          real_amount: {
            placeholder: '请输入实际付款金额',
            rules: {
              required: true,
              message: '实际付款金额未填写',
              regulation: 'gt_str',
              rulesData: 0
            }
          }

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {

      // 关闭方法
      closeDialog() {

        _this.show = false;

        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

        _this.money = 0;

      },

      // 提交按钮
      enjoySubmit() {

        _this.$post(
            '/driver/fineDriverModeSubmit',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            _this.$message.success({
						message: '添加优享司机成功',
						duration:1500
					});
            _this.$emit('onSubmit');
            _this.closeDialog();

          }).catch((err) => {

          })

      },

      // 获取钱数，在输入天数时触发
      getMoney(val) {
        if (val != '' && val != null) {
          _this.$post(
              '/driver/getFineDriverModeAmount', {
                day_num: _this.submit_data.day_num
              }
            )
            .then(res => {

              _this.money = res.data.price

            }).catch((err) => {

            })
        } else {

          _this.money = 0;

        }


      }
    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>